export const POLICY = {
  isHidden: true,
  nickname: 'PRODUCTS.POLICY.nickname',
  icon:'policy'
};
